import React from "react";
import foto from "../../images/Calendario Cigno 20232024.jpg"
import FrecciaIndietro from "../../commons/FrecciaIndietro";
import Space from "../../commons/Space";
import black from "../../images/News/Black_friday.jpg"
import TitoloSezioni from "../../commons/TitoloSezioni";
import "./NewsPagesFoto.css"
import ScrollToTopOnMount from "../../components/ScrollToTopOnMount";


function BlackFridayNews () {
    return(
        <div className="text-center">
            <ScrollToTopOnMount />
            <FrecciaIndietro indirizzo={"/news"} />
            <p className="text-center" style={{ fontSize: "22px", fontFamily: "Hammersmith One" }}>{"18.11.2024"}</p>
            <TitoloSezioni title={"Black Friday"} />
            <div className="container-foto-news m-auto" style={{display: "flex", flexDirection: "column"}}>
                <a style={{alignSelf: "end"}} href={black} download>
                    <i style={{fontSize: "2em", color: "grey", marginRight: "0.5em"}} className="bi bi-download"></i>
                </a>
                <img src={black} style={{width: "100%"}}></img>
            </div>
            <Space />

        </div>
    )
}
export default BlackFridayNews